import { defineStore } from "pinia";
import { fetchCurrentUser } from "@/api/vigico-back/user";

export const useUserStore = defineStore("user", {
  state: () => ({
    uuid: null,
    usermanagementUuid: null,
    firstName: null,
    lastName: null,
    email: null,
    agencyUuid: null,
    agencyGroupUuid: null,
    managedAgencyGroupUuids: [],
    agencyScopeUuids: [],
    agencyScopeGroupUuids: [],
    groups: [],
  }),

  actions: {
    async loadCurrentUser() {
      const user = await fetchCurrentUser();
      this.uuid = user.uuid;
      this.usermanagementUuid = user.usermanagementUuid ?? null;
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.email = user.email;
      this.agencyUuid = user.agencyUuid ?? null;
      this.agencyGroupUuid = user.agencyGroupUuid ?? null;
      this.managedAgencyGroupUuids = user.managedAgencyGroupUuids ?? [];
      this.agencyScopeUuids = user.agencyScopeUuids ?? [];
      this.agencyScopeGroupUuids = user.agencyScopeGroupUuids ?? [];
      this.groups = user.groups ?? [];
    },
  },
});
